/**
 * 提交中和提交成功的GIF图地址
 */
export const CREATION_SUBMIT_ICON = {
  SUBMITTING:
    'https://p16-ttam-va.ibyteimg.com/tos-maliva-i-o1lobgzm8y-us/va-creation-submitting.gif~tplv-o1lobgzm8y-image.image',
  SUCCESS:
    'https://p16-ttam-va.ibyteimg.com/tos-maliva-i-o1lobgzm8y-us/va-creation-success_v1.gif~tplv-o1lobgzm8y-gif-75-origin:0:0.image',
};
